const STORAGE_KEY = "mintly.recentMintSpaces";
const MAX_ENTRIES = 50;

function readMap() {
  if (typeof window === "undefined") return {};
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

function writeMap(map) {
  if (typeof window === "undefined") return;
  const entries = Object.entries(map).sort((a, b) => b[1] - a[1]).slice(0, MAX_ENTRIES);
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(Object.fromEntries(entries)));
}

function recordMintSpaceActivity(spaceId) {
  if (!spaceId) return;
  const id = String(spaceId);
  const map = readMap();
  map[id] = Date.now();
  writeMap(map);
}

/** Record meaningful activity inside a mint space and reorder the sidebar switcher. */
export function notifyMintSpaceActivity(spaceId) {
  if (!spaceId) return;
  recordMintSpaceActivity(spaceId);
  window.dispatchEvent(
    new CustomEvent("mintSpaceInteraction", { detail: { mintSpaceId: String(spaceId) } })
  );
}

export function getMintSpaceActivityTime(spaceId) {
  if (!spaceId) return 0;
  return readMap()[String(spaceId)] || 0;
}

/**
 * Most recently active first. Falls back to API `updatedAt` / `createdAt` when the
 * user hasn't interacted with a space from this browser yet.
 */
export function sortMintSpacesByRecent(spaces) {
  if (!Array.isArray(spaces) || spaces.length === 0) return [];
  const map = readMap();
  return [...spaces].sort((a, b) => {
    const aId = String(a._id);
    const bId = String(b._id);
    const aRecent = map[aId] || 0;
    const bRecent = map[bId] || 0;
    if (bRecent !== aRecent) return bRecent - aRecent;
    const aTime = new Date(a.updatedAt || a.createdAt || 0).getTime();
    const bTime = new Date(b.updatedAt || b.createdAt || 0).getTime();
    return bTime - aTime;
  });
}
